export default __webpack_public_path__ + "static/media/SEA_8699.feb2d143.jpg";